export const routeAnimationDuration = 200
